import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-table__cell gfu-table__cell-row _flexb50 _flexb75--s _flexb60--m _flexb60--xl _pa-0" }
const _hoisted_3 = { class: "_screen--none _screen--s gfu-table__cell--image _mr-3 _fl gfu-table__thumb" }
const _hoisted_4 = { class: "gfu-table__cell--grow _pt-1 _pb-1 _flexcol _ai-fs" }
const _hoisted_5 = {
  class: "gfu-table__text--strong gfu-table__text--big",
  "data-qa": "cart-table:ProductName"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "gfu-table__cell gfu-table__cell--actions _tac _flexb15 _flexb10--s",
  "data-qa": "cart-table:ProductQuantity"
}
const _hoisted_9 = {
  class: "gfu-table__cell _tar _flexb35 _flexb25--s _flexb15--m",
  "data-text": "Total price"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "gfu-table__cell _tar _pa-0 _flexb5 _screen--none _screen--s"
}
const _hoisted_12 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", {
    class: "gfu-table__row gfu-table__row--short",
    "data-qa": `cart-table:${_ctx.item.orderItemTypeName}`
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_image, { src: $options.imageUrl }, null, 8 /* PROPS */, ["src"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.item.displayName), 1 /* TEXT */),
        (_ctx.canDelete)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              disabled: _ctx.isProcessing,
              class: "_pl-0 _mt-0 _tc--error _screen--not-s",
              onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.setOrderItemQuantity(0, _ctx.item)), ["prevent"]))
            }, _toDisplayString(_ctx.Resources.Checkout.RemoveItemButton), 9 /* TEXT, PROPS */, _hoisted_6))
          : _createCommentVNode("v-if", true),
        (_ctx.item.displayName !== _ctx.item.orderItemTypeName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.item.orderItemTypeName), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", null, _toDisplayString(_ctx.item.quantity), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", null, _toDisplayString(_ctx.priceFormatted), 1 /* TEXT */),
      (_ctx.showTaxValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.taxFormatted), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    (_ctx.allowEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          ($options.canRemove)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "gfu-btn gfu-btn--icon",
                disabled: _ctx.isProcessing,
                onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.setOrderItemQuantity(0, _ctx.item)), ["prevent"]))
              }, [
                _createVNode(_component_base_icon, {
                  name: "times-circle",
                  class: "_tc--error",
                  "data-qa": "begin-order-form-button:RemoveItem"
                })
              ], 8 /* PROPS */, _hoisted_12))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1))
}